import {BaseCriteriaModel} from './base-criteria.model';
import {Optional} from 'typescript-optional';

export class MembershipPointTotalQueryCriteriaClass extends BaseCriteriaModel {

  //bl_crm_membership_points_txn_line table
  card_no?: Optional<string> = Optional.empty();
  membership_hdr_guid?: Optional<string> = Optional.empty();
  date_txn?: Optional<string> = Optional.empty();
  date_valid_from?: Optional<string> = Optional.empty();
  date_valid_to?: Optional<string> = Optional.empty();
  points_type?: Optional<string> = Optional.empty();
}

export class MembershipPointTotalCriteriaModelQuery {
  query = '';

  constructor(MembershipPointTotalCriteriaModel: MembershipPointTotalQueryCriteriaClass) {

    if (!MembershipPointTotalCriteriaModel) {
      return;
    }

    this.query += MembershipPointTotalCriteriaModel.card_no.filter(x => x !== '').map(x => '&card_no=' + x).orElse('');
    this.query += MembershipPointTotalCriteriaModel.membership_hdr_guid.filter(x => x !== '').map(x => '&membership_hdr_guid=' + x).orElse('');
    this.query += MembershipPointTotalCriteriaModel.date_txn.filter(x => x !== '').map(x => '&date_txn=' + x).orElse('');
    this.query += MembershipPointTotalCriteriaModel.date_valid_from.filter(x => x !== '').map(x => '&date_valid_from=' + x).orElse('');
    this.query += MembershipPointTotalCriteriaModel.date_valid_to.filter(x => x !== '').map(x => '&date_valid_to=' + x).orElse('');
    this.query += MembershipPointTotalCriteriaModel.points_type.filter(x => x !== '').map(x => '&points_type=' + x).orElse('');

    this.query += '&status=' + MembershipPointTotalCriteriaModel.status;
    this.query += '&orderBy=' + MembershipPointTotalCriteriaModel.orderBy;
    this.query += '&order=' + MembershipPointTotalCriteriaModel.order;
    this.query += '&offset=' + MembershipPointTotalCriteriaModel.offset + '&limit=' + MembershipPointTotalCriteriaModel.limit;
  }
}
